export * from '@redux-saga/core/effects';



//////////////////
// WEBPACK FOOTER
// ./~/veritone-redux-common/~/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js
// module id = hN9v
// module chunks = 22